import { requestGet } from "../../../Helpers"

export const getWishList = async (id) => {
    
    return await requestGet(`wishlists/?user=${id}`)
        .then((data) => {
            return data
        });
    
}
